module.exports = __webpack_public_path__ + "img/with-md.7a3c2fa6.svg";